import { render, staticRenderFns } from "./Gratificaciones.vue?vue&type=template&id=6cef0881"
import script from "./Gratificaciones.vue?vue&type=script&lang=js"
export * from "./Gratificaciones.vue?vue&type=script&lang=js"
import style0 from "./Gratificaciones.vue?vue&type=style&index=0&id=6cef0881&prod&lang=css"
import style1 from "./Gratificaciones.vue?vue&type=style&index=1&id=6cef0881&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports